import { render, staticRenderFns } from "./questions-step.vue?vue&type=template&id=68b7727a"
import script from "./questions-step.vue?vue&type=script&lang=js"
export * from "./questions-step.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports